import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'

Vue.use(VueRouter)

// 静态路由：后端未提供菜单/权限树接口，菜单按模块固定（后续有权限接口再改为动态生成）
const routes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/login.vue'),
        meta: { title: '登录' }
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error/404.vue'),
        meta: { title: '页面不存在' }
    },
    {
        path: '/',
        component: Layout,
        redirect: '/userList',
        children: [
            {
                path: 'userList',
                name: 'userList',
                component: () => import('@/views/userList/userList.vue'),
                meta: { title: '用户管理' }
            },
            {
                path: 'appList',
                name: 'appList',
                component: () => import('@/views/appList/appList.vue'),
                meta: { title: '接入方管理' }
            },
            {
                path: 'groupList',
                name: 'groupList',
                component: () => import('@/views/groupList/groupList.vue'),
                meta: { title: '客户群查询' }
            },
            {
                path: 'messageList',
                name: 'messageList',
                component: () => import('@/views/messageList/messageList.vue'),
                meta: { title: '消息查询' }
            },
            {
                path: 'archiveStatus',
                name: 'archiveStatus',
                component: () => import('@/views/archiveStatus/archiveStatus.vue'),
                meta: { title: '存档状态' }
            }
        ]
    },
    {
        path: '*',
        redirect: '/404'
    }
]

const router = new VueRouter({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes
})

// 全局屏蔽 Vue Router 重复导航到当前路由的控制台报错
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') return Promise.reject(err)
    })
}
VueRouter.prototype.replace = function (location) {
    return originalReplace.call(this, location).catch(err => {
        if (err.name !== 'NavigationDuplicated') return Promise.reject(err)
    })
}

export default router
